"use client";

import { FunctionComponent } from "react";
import { TailwindColors } from "../types/general";
import { Wrapper } from "./spinner.styles";

export interface SpinnerProps {
    /**
     * Color of the spinner.
     */
    color?: keyof TailwindColors | undefined;

    /**
     * Size of the spinner.
     */
    size?: "md" | "lg";

    /**
     * Whether to center the spinner or not.
     */
    center?: boolean | false;

    /**
     * Space around the spinner.
     */
    space?: "sm" | "md" | "lg";

    /**
     * Class name of the spinner.
     */
    className?: string;
}

export const Spinner: FunctionComponent<SpinnerProps> = ({ color, size, center, space, className }) => {
    return <Wrapper color={color} size={size} center={center} space={space} className={className}></Wrapper>;
};
